export const getEncryptPseudonymCount = (state) =>
    state.encryptPseudonym.encryptPseudonyms.maxCount;
